export enum LocalStorageKeys {
  INTAKE_FORM_STATE = 'intake-form-state',
  SHOW_APPLICATIONS_BANNER = 'show-applications-banner',
  SHOW_APPLICATIONSV2_BANNER = 'show-applicationsv2-banner',
  SHOW_AUTOMATION_CONNECT_BANNER = 'show-automation-connect-banner',
  SHOW_AUTOMATION_ERROR_BANNER = 'show-automation-error-banner',
  SHOW_CUSTOMIZE_TASKS_BANNER = 'show-customize-tasks-banner',
  SHOW_EMPLOYEE_GROUPS_BANNER = 'show-employee-groups-banner',
  SKIP_INTAKE_FORM = 'skip-intake-form',
  USER_ACCOUNTS_TABLE_COLUMNS_VISIBILITY = 'user-accounts-table-columns-visibility',
  ASSET_MANAGEMENT_TABLE_COLUMNS_VISIBILITY = 'asset-management-table-columns-visibility',
  DEVICES_TABLE_COLUMNS_VISIBILITY = 'devices-table-columns-visibility',
  EMPLOYEE_TASKS_TABLE_COLUMNS_VISIBILITY = 'employee-tasks-table-columns-visibility',
  PEOPLE_TABLE_COLUMNS_VISIBILITY = 'people-table-columns-visibility',
  INACTIVE_PEOPLE_TABLE_COLUMNS_VISIBILITY = 'inactive-people-table-columns-visibility',
  PENDING_PEOPLE_TABLE_COLUMNS_VISIBILITY = 'pending-people-table-columns-visibility',
  ALL_PEOPLE_TABLE_COLUMNS_VISIBILITY = 'all-people-table-columns-visibility',
  YOUR_IT_PLAN_STATE = 'your-it-plan-state',
  GETTING_STARTED_PROGRESS = 'getting_started_progress',
  TRINET_ORGANIZATION_APP = 'trinet-organization-app',
  ELECTROLYTE_THEME = 'electrolyte-theme',
  I18NEXT_LANGUAGE = 'i18nextLng',
}
